export interface Paper {
  id: string;
  title: string;
  authors: string;
  venue: string;
  date: string;
  keywords: string[];
  tldr: string;
  abstract: string;
  link: string;
}

export interface ReadPaper {
  id: string;
  title: string;
  authors: string;
  dateRead: string;
  link: string;
  review: string;
  takeaways: string[];
}

export const papers: Paper[] = [
  {
    id: '1',
    title: 'Bridging the Gap in Few-Shot Medical Image Segmentation: Multi-Task Learning Outperforms Foundation Models in Boundary Precision',
    authors: "Oluwabukola Grace Adegboro, Julia Dietlmeier, Jai Choraria, Ilker Hacihaliloglu, Claudia Mazo, Noel O'Connor",
    venue: 'BMVC 2026 (British Machine Vision Conference), Conference Submission — accepted',
    date: 'May 2026',
    keywords: ['Multi-task Learning', 'Image Segmentation', 'Brain Tumor', 'Boundary Precision'],
    tldr: 'We investigate several multi-task learning architectures in few-shot settings on the task of brain tumor segmentation.',
    abstract: 'Data scarcity remains a major challenge for medical image segmentation, particularly in few-shot settings where dense pixel-level annotations are limited. While Fully Supervised Segmentation (FSS) serves as a standard baseline, its performance can degrade substantially under sparse supervision. This study investigates whether Multi-Task Learning (MTL), by jointly optimizing classification and segmentation objectives, can improve segmentation robustness and localization quality on brain tumor MRI datasets. We evaluate a diverse range of architectures, including Convolutional Neural Networks (ResNet), transformer-based architectures (Swin Transformer and Vision Transformer), vision-language foundation models such as CLIP and BioMedCLIP, and segmentation foundation models such as SAM. Our results show that MTL improves segmentation stability and boundary-aware performance in few-shot regimes, although the magnitude of improvement depends on the backbone and dataset. With only less than 1% of training data, the proposed MTL-Fusion model with a SEA1-ResNet50 backbone improves Dice from 0.472 to 0.593 relative to its FSS counterpart. Although SAM achieves the highest overlap (Dice = 0.650), it yields a higher HD95 than MTL-Fusion (28.06 vs. 18.72), indicating weaker boundary localization despite stronger regional overlap. These results suggest that auxiliary classification supervision can act as an effective regularizer for improving segmentation robustness and contour localization under limited annotation. Code will be made publicly available upon acceptance.',
    link: 'public/assets/917_Bridging_the_Gap_in_Few_Sh.pdf'
  }
];

export const readPapers: ReadPaper[] = [
  {
    id: '1',
    title: 'Attention Is All You Need',
    authors: 'Ashish Vaswani et al.',
    dateRead: 'June 2024',
    link: 'https://arxiv.org/abs/1706.03762',
    review: 'A foundational paper that introduced the Transformer architecture, dispensing with recurrence and convolutions entirely. It completely changed how I think about sequence modeling and information routing in neural networks.',
    takeaways: [
      'Self-attention mechanisms allow global dependencies to be drawn between input and output.',
      'Transformer architectures are highly parallelizable compared to RNNs/LSTMs.',
      'Positional encoding is necessary since there is no inherent sequence processing.'
    ]
  }
];